(function () {
  var FRAME_ID = "inqChatStage";
  var TC_CHAT_LOADER_P_CSS =
    "font-family: Arial,sans-serif;" +
    "font-size: 42px;" +
    "margin: 0 !important;" +
    "position: absolute;" +
    "top: 45%;" +
    "left: 50%;" +
    "transform: translate(-50%, -50%);" +
    "width: 200px !important;" +
    "text-align: center;";
  var STYLE_HIDDEN =
    "overflow: hidden; position: absolute;" +
    " height: 1px; width: 1px; left: 0px; top: 0px;" +
    " border-style: none; border-width: 0px;";

  function log(message) {
    if (typeof console != "undefined" && console.log) {
      console.log(message);
    }
  }

  function secureProtocol(url) {
    return url.replace(/^HTTPS?:/i, "https:");
  }

  /**
   * encode URL only when it is not encoded already
   * @param urlStr - url string to encode
   * @returns {*} encoded url
   */
  function encodeURLIfNotEncoded(urlStr) {
    var decodedUrlStr;
    if (!urlStr) {
      return urlStr;
    }

    try {
      decodedUrlStr = decodeURI(urlStr);
      // not encoded yet
      if (decodedUrlStr.length === urlStr.length) {
        return encodeURI(urlStr);
      }
    } catch (err) {
      // happens when urlString contains %, meaning the string is already encoded.
    }
    return urlStr;
  }

  v3Lander.v3Frame = false;
  v3Lander.domReady = false;
  v3Lander.domState = "defer-failed";
  v3Lander.hostedFileURL = v3Lander.getV3LanderConfigProperty(
    "hostedFileURL",
    v3Lander.v3HostedFileURL
  );
  v3Lander.isAtHostedFileURL = false;
  v3Lander.embeddedHostedFile = null;
  v3Lander.embeddedDiv = null;
  v3Lander.c2cQueryData = null;
  v3Lander.registerDivRetry = 0;
  v3Lander.buDataCallbackFcn = null;
  v3Lander.inqSiteDataFun = null;
  v3Lander.inqRulesEngineFun = null;
  v3Lander.programRulesConfig = null;
  v3Lander.mbusToLoad = [];
  v3Lander.page = null;
  v3Lander.cgIDs = null;
  v3Lander.loadedMbuRuleDataFuns = [];
  /*
   * Data Object used by site_..._default_jssdk.js and tcFramework_jssdk.js.
   * It is initialized in site_..._default_jssdk.js after get site data
   * and business rules from the server through JSON API.
   * Currently site data in inqChatLaunch--v3Lander file--is not using
   * jsonAPIData but potentially we need get json data at
   * the beginning of v3Lander file and initialize v3Lander object.
   */
  v3Lander.jsonAPIData = null;
  /*
   * Data Object used by v3Lander file to store the JSON data of business rules
   * for certain Business Unit only. The JSON is obtained
   * through the json mbu API. See the initialization code in loadMbuData() function.
   */
  v3Lander.jsonMbuData = null;
  v3Lander.reInitChatData = null;

  /**
   * v3Lander is a modification of time tested code
   * in establishHostedFileURL below.
   * Except that it accepts the domain as a parameter instead of getting
   * it from "window.location.domain".
   *
   * @param domain - the domain for which we want the hosted file
   * @return the hosted file path, in format "//domain/path" or "/path"
   */
  function _getHostedFileURL(domain) {
    if (!domain) {
      // if domain has not been supplied, use our domain
      domain = window.location.host;
    }
    domain = domain.toUpperCase();
    // If we have no host-to-path map, then return the default URL
    if (v3Lander.hostToPath && v3Lander.hostToPath[domain]) {
      return v3Lander.hostToPath[domain];
    } else {
      return v3Lander.hostedFileURL;
    }
  }

  /**
   * Sets the v3Lander.hostedFileURL property according to the overridden path from v3Lander.hostToPath
   * if an overriding value exists.
   */
  function _setHostedFileURL(domain) {
    if (!domain) {
      // if domain has not been supplied, use current window domain
      domain = window.location.host;
    }
    domain = domain.toUpperCase();
    // If we have no host-to-path map, then hosted file URL is not updated
    if (v3Lander.hostToPath && v3Lander.hostToPath[domain]) {
      v3Lander.hostedFileURL = v3Lander.hostToPath[domain];
    }
  }

  /**
   * Dynamically load a json file.
   *
   * @param {string} url - url to request
   * @param {function} callback - callback function
   * @param {string} nameForLog - name of called request for error logs
   */
  function loadJSON(url, callback, nameForLog) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          callback(xhr.responseText);
        } else if (xhr.status === 0) {
          // Network issue.
          console.error(
            "Get " + nameForLog + " with network issue. Status: " + xhr.status
          );
        } else {
          console.error(
            "Get " + nameForLog + " fail with status: " + xhr.status
          );
        }
      }
    };
    xhr.open("GET", url, true);
    xhr.send();
  }

  v3Lander.showLoader = function showLoader() {
    var loader = document.createElement("div");
    loader.id = "tc-chat-loader";
    var paragraph = document.createElement("p");
    paragraph.style.cssText = TC_CHAT_LOADER_P_CSS;
    var text = document.createTextNode("Loading...");
    paragraph.appendChild(text);
    loader.appendChild(paragraph);
    document.body.appendChild(loader);
  };

  v3Lander.showLoaderAnim = function showLoaderAnim() {
    var content =
      "<style> @keyframes rotate {from {transform: rotate(0deg);}to {transform: rotate(360deg);}}@-webkit-keyframes rotate {from {-webkit-transform: rotate(0deg);}to {-webkit-transform: rotate(360deg);}}.load {width: 200px;height: 200px;margin-left: auto;margin-right: auto;margin-top: 30vh;border: solid 10px rgb(68, 68, 68);border-radius: 50%;border-top-color: transparent;border-right-color: transparent;-webkit-transition: all 0.5s ease-in;-webkit-animation-name: rotate;-webkit-animation-duration: 1.0s;-webkit-animation-iteration-count: infinite;-webkit-animation-timing-function: linear;transition: all 0.5s ease-in;animation-name: rotate;animation-duration: 1.0s;animation-iteration-count: infinite;animation-timing-function: linear;}</style>";
    content +=
      "<div class='load' role='progressbar' aria-valuetext='Loading...' aria-valuemin='0' aria-valuemax='100'></div>";
    var loader = document.createElement("div");
    loader.id = "tc-chat-loader";
    loader.innerHTML = content;
    document.body.appendChild(loader);
  };

  /**
   * Gets the qualified URL of the hosted file, given the domain
   *
   * @param domain - string containing the domain of the client page
   * @return fully qualified hosted page
   */
  v3Lander.getHostedFileURL = function getHostedFileURL(domain) {
    // Get the unqualified hosted page
    var url = _getHostedFileURL(domain);
    if (url.indexOf("//") != 0) {
      /*
       * If the hosted file not start with double backslashes
       * then it needs to add the domain.
       */
      url = "//" + domain + url;
    }
    // Now add the protocol
    url = window.location.protocol + url;
    // URL is now in the format of protocol://domain/path
    return url;
  };

  /**
   * Establishes the v3Lander.hostedFileURL property via _setHostedFileURL
   * in accordance with the override of the v3Lander.hostToPath property
   * according to the customized override value from v3LanderConfig.hostToPath.
   *
   * We need to check all the values in the local customized settings object
   * v3LanderConfig.hostToPath to replace the initial configuration defined
   * in v3Lander.hostToPath.
   *
   * @see _setHostedFileURL
   */
  v3Lander.establishHostedFileURL = function establishHostedFileURL() {
    /** @type {Array} */
    var hostPaths = this.getV3LanderConfigProperty("hostToPath", []);
    for (var i = 0, paths = hostPaths; i < paths.length; i++) {
      if (paths[i].domain && paths[i].hostedFileDirectory) {
        this.hostToPath[paths[i].domain.toUpperCase()] =
          paths[i].hostedFileDirectory + this.hostedFileURL;
      }
    }
    _setHostedFileURL();
  };

  /**
   * v3Lander method is to check if we are in the same domain as client page domain.
   * If not we are trying to assign the right domain.
   */
  v3Lander.assignDomain = function assignDomain() {
    if (this.isAtHostedFileURL) {
      var domainName = document.domain;
      var temp = domainName.split(".");
      for (var i = 0; i < temp.length; i++) {
        try {
          var tempwindow = null;
          if (window.location.search == "") {
            tempwindow = window.opener;
          } else if (
            window.location.search.indexOf("?IFRAME") == 0 ||
            window.location.search == "?IEXF"
          ) {
            /*
             * ?IEXF - For posting a return from "PostToServer.html"
             * for IE browsers, v3Lander stands for IE XFer.
             */
            tempwindow = window.parent;
          } else if (window.location.search == "?BLNK") {
            tempwindow = window.parent;
          } else if (window.location.search == "?XHR") {
            // ?XHR - v3Lander is for returning information for the XMLHttpRequest proxy.
            tempwindow = window.parent.parent;
          } else {
            return;
          }

          /*
           * Except in FF5 browser , all other browsers
           * throw an error if we try to access parent domain
           * from the current window, when the the parentdomain
           * is not matching up with the current window domain.
           * It is not the case in FireFox version 5 and need
           * to add the else block to assign the
           * right domain so that both the parent
           * and the current window domain matches.
           */
          if (document.domain == tempwindow.document.domain) {
            break;
          } else {
            temp.shift();
            if (temp.length > 1) {
              document.domain = temp.join(".");
            }
          }
        } catch (ee) {
          temp.shift();
          if (temp.length > 1) {
            document.domain = temp.join(".");
          }
        }
      }
    }
  };

  /**
   * resizeAnscestorIframe - resizes the grand-child window to the specified width height
   * The parameters for v3Lander function are in the window name of v3Lander window.
   * as follows: "RESIZE||iframe_name||width||height
   * where:
   *   iframe_name is the name of the IFRAME that we want to resize
   *   width is the actual numeric width to resize to
   *   height is the actual numeric height to resize to.
   * The IFRAME is in the grand-child window accessible by parent.parent
   */
  v3Lander.resizeAnscestorIframe = function resizeAnscestorIframe() {
    // Separate the parameters
    var items = name.split("||");
    // param(1) is the name of the IFRAME
    var iframeName = items[1];
    // param(2) is the width as a number
    var width = items[2];
    // param(3) is the height as a number
    var height = items[3];
    // Now get a collection of elements with the given name (parameter 1)
    var iframeElements = parent.parent.document.getElementsByName(iframeName);
    // if the named item exists, then reference the first one
    if (iframeElements.length > 0) {
      try {
        // get the iframe
        var iframe = iframeElements[0];
        // now fix the style for the IFRAME
        iframe.style.cssText +=
          ";width: " +
          width +
          "px;" +
          "height: " +
          height +
          "px;" +
          "display: block;" +
          "overflow: hidden;" +
          "overflow-x: hidden;" +
          "overflow-y: hidden;" +
          "border-style: hidden;" +
          "border-style: none;" +
          "border-width: 0px;";
      } catch (e) {}
    }
  };

  /**
   * registerDiv - Registers the div layer to the top client IJSF
   * It first establishes the retry count (if supplied or not zero)
   * Then it checks to see if the Inq structure and fire custom event function exist.
   * If not, it throws.
   * Upon any throw, the registerDiv is retried after a 500ms delay
   *
   * @param retryCount - (optional) the number of retries to attempt
   */
  v3Lander.registerDiv = function registerDiv(retryCount) {
    if (!!retryCount) {
      v3Lander.registerDivRetry = retryCount;
    }
    try {
      if (top["Inq"] == null) {
        throw new Error("Inq not ready");
      }
      if (top.Inq["fireCustomEvent"] == null) {
        throw new Error("fireCustomEvent not ready");
      }
      top.Inq.fireCustomEvent("IframeC2C", {
        div: v3Lander.embeddedDiv,
        queryData: v3Lander.c2cQueryData,
      });
    } catch (e) {
      if (--v3Lander.registerDivRetry > 0) {
        window.setTimeout(v3Lander.registerDiv.bind(this), 500);
      }
    }
  };

  /**
   * resizeIframe - resizes the IFRAME via a new grand-child IFRAME with same domain
   * The grand-child iframe does the actual resizing
   * When the grand-child iframe comes up, it checks the query string
   * and sees that we want a resize (the query is "RSC2C" for ReSize C2C)
   * Then it calls the method resizeAnscestorIframe
   *
   * @param width - width of the image
   * @param height - height of the image
   * @see resizeAnscestorIframe (above)
   */
  v3Lander.resizeIframe = function resizeIframe(width, height) {
    /** @see RTDEV-11045 */
    var winName = !!window.name
      ? window.name.replace(/\n|<.*?>/g, "").replace(/\"/g, "\\'")
      : window.name;
    var name = "RESIZE||" + winName + "||" + width + "||" + height;
    var div = document.createElement("div");
    div.innerHTML =
      "<ifr" +
      'ame id="inqChatStage" name="' +
      name +
      '" src="' +
      v3Lander.embeddedHostedFile +
      '?RSC2C"' +
      ' style="z-index:9999999; display: none; ' +
      STYLE_HIDDEN +
      '" scrolling="NO"' +
      "></ifr" +
      "ame>";
    var ifrm = div.firstChild;
    document.body.appendChild(ifrm);
  };

  /**
   * setSource - Sets the source and other stuff as attributes.
   * Let me explain, the attributes are sent up with souch things as:
   *       onclick, style, src
   * Also the domain of the embedded client IFRAME is supplied,
   * v3Lander is needed to perform the resizing of the C2C Iframe
   * Please see resizeIframe above.
   *
   * @param attributes - and object (map) containing the desired attributes
   * @param domain - domain of the embedded client IFRAME
   *
   * @see resizeIframe
   */
  v3Lander.setSource = function setSource(attributes, domain) {
    v3Lander.embeddedHostedFile = v3Lander.getHostedFileURL(domain);
    // Clear out all the HTML from the DIV, we want to start off clean
    v3Lander.embeddedDiv.innerHTML = "";
    /*
     * We are creating the image, because the created image can be
     * used to get the width and height at load time
     */
    var image = new Image();
    // Before we apply the attributes, we must add the "onload" handler so we can get width and height
    image.onload = function (e) {
      /*
       * At the time of image load, "v3Lander" points to the target image
       * And v3Lander.width and v3Lander.height contain the width and height of the image
       */
      v3Lander.resizeIframe(this.width, this.height);
      return false;
    };
    // Now that we have a listener for "load" we can now apply all attributes
    for (var attr in attributes) {
      image.setAttribute(attr, attributes[attr]);
    }
    v3Lander.embeddedDiv.appendChild(image);
  };

  v3Lander.fixV3IFrames = function fixV3IFrames(div) {
    var inqFrames = div.getElementsByTagName("IFRAME");
    div.style.cssText = STYLE_HIDDEN;
    for (var ix = 0, l = inqFrames.length; ix < l; ix++) {
      inqFrame = inqFrames[ix];
      inqFrame.allowTransparency = "true";
      inqFrame.border = "0";
      inqFrame.frameSpacing = 0;
      inqFrame.marginWidth = 0;
      inqFrame.style.cssText =
        STYLE_HIDDEN + " z-index: 9999999; BACKGROUND-COLOR: Transparent;";
    }
  };

  v3Lander.initV3Frame = function initV3Frame() {
    if (window.frameElement) {
      window.clientwin = window.parent;
    } else if (window.opener) {
      window.clientwin = window.opener;
    }
    if (window.clientwin) {
      window.clientwin.inqFrame = window;
    }
    window.inqFrame = window;
    if (window.inqFrame != window.parent) {
      window.name = opener ? "_inqPersistentChat" : "inqV3";
    }

    insertLandingTag();
  };

  /**
   * The reload is used for Virtual Page Reload feature.
   * v3Lander is to re-fire the chat for a new pageID
   */
  v3Lander.reload = function reload() {
    this.domReady = false;
    setTimeout(_reload.bind(this), 50);
  };

  function _reload() {
    var chatStage = document.getElementById(FRAME_ID);
    var corner = document.getElementById("inqDivResizeCorner");
    var title = document.getElementById("inqTitleBar");
    if (chatStage) {
      document.body.removeChild(chatStage);
    }
    if (corner) {
      document.body.removeChild(corner);
    }
    if (title) {
      document.body.removeChild(title);
    }
    window.inqFrame = null;
    window.Inq = undefined;
    this.start();
  }

  v3Lander.createV3Frame = function createV3Frame(win) {
    if (top.document.getElementById(FRAME_ID)) {
      return;
    }
    if (!win) {
      win = window;
    }

    var maxIframeCreateAttemptCount = v3Lander.maxIframeCreateAttemptCount || 0;
    var doc = win.document;
    var params = win.location.search.replace("?", "").split("&");
    var attemptCount = 0;

    for (var i = 0; i < params.length; i++) {
      if (params[i].indexOf("nuance-frame-ac=") === 0) {
        attemptCount = parseInt(params[i].split("=")[1], 10);
        attemptCount++;
      }
    }

    if (
      !isNaN(attemptCount) &&
      maxIframeCreateAttemptCount !== 0 &&
      attemptCount > maxIframeCreateAttemptCount
    ) {
      return;
    }

    var div = doc.createElement("div");
    var port = doc.location.port == "" ? "" : ":" + doc.location.port;
    var iframesrc;
    if (v3Lander.hostedFileURL.indexOf("/") === 0) {
      iframesrc =
        doc.location.protocol +
        "//" +
        doc.location.hostname +
        port +
        this.hostedFileURL +
        "?IFRAME" +
        (window.v3LanderConfig.iframeSrcParams || "");
    } else {
      iframesrc = v3Lander.hostedFileURL;
    }

    if (iframesrc.indexOf("http") !== 0) {
      return;
    }

    var prefix = iframesrc.indexOf("?") === -1 ? "?" : "&";
    iframesrc += prefix + "nuance-frame-ac=" + attemptCount;

    if (v3Lander.isJSSDK || v3Lander.useJSHelperForIJSF) {
      /*
       * before loading iframes, load the helper file with functions
       * that need to be executed in top window
       */
      var helperPath = "";
      var env = getEnvFromConfig();
      if (v3Lander.noJSHosting && env) {
        helperPath = "/" + env;
      }
      helperPath += generatePath(
        "site_" + v3Lander.siteID + "_default_helper.js"
      );
      loadScript(helperPath, true, true);
    }

    if (
      typeof CEAPI_POST_CHAT_SURVEY_DATA != "undefined" &&
      CEAPI_POST_CHAT_SURVEY_DATA != null
    ) {
      /*
       * We are loading from tagserver servlet /showPostChatSurvey
       * responded page now. We need to use the same /showPostChatSurvey
       * url to load the inqLaunch<site>.js into the IFrame to avoid
       * cross-domain issue. We also pass in the hostedFileURL param
       * to let /showPostChatSurvey servlet know it is not called
       * from ceapi client. Also passing in the siteID and vanityDomain.
       */
      iframesrc =
        doc.location +
        "?IFRAME&hostedFileURL=true&siteID=" +
        v3Lander.siteID +
        "&vanityDomain=" +
        secureProtocol(
          window.v3LanderConfig.vanityDomain || v3Lander.vanityDomain
        );
    }

    /*
     * Rand parameter is added to avoid browser iframe recursion block which prevented hosted file from loading
     * inside of XForms IFrame (http://forms.inq.com/orbeon/...).
     */
    if (top != parent) {
      var rand = Math.round(Math.random() * 1000000000000).toString(36);
      iframesrc += iframesrc.indexOf("?") == -1 ? "?" : "&";
      iframesrc += "rand=" + rand;
    }

    div.id = FRAME_ID;
    div.style.cssText = "z-index:9999999; " + STYLE_HIDDEN;
    iframesrc = encodeURLIfNotEncoded(iframesrc);
    div.innerHTML =
      '<iframe id="inqChatStage" title="Chat Window"' +
      ' name="' +
      v3Lander.siteID +
      '" src="' +
      iframesrc +
      '"' +
      ' style="z-index:9999999; display: none;' +
      STYLE_HIDDEN +
      '"' +
      "></iframe>" +
      '<div id="inqTitleBar" style="border-width: 0px; position: absolute;' +
      " z-index: 9999999; left: 0px; top: 0px; cursor: move;" +
      ' height: 55px; width: 410px; display: none;"></div>' +
      '<div id="inqResizeBox" style="border-width: 0px; position: absolute;' +
      ' z-index: 9999999; left: 0px; top: 0px; display:none; height: 0px; width: 0px;">' +
      '<div id="inqDivResizeCorner" style="border-width: 0px; position: absolute;' +
      " z-index: 9999999; left: 424px; top: 284px; cursor: se-resize;" +
      ' height: 16px; width: 16px; display: none;"></div>';
    var bdy = doc.body;
    if (bdy) {
      var iframes = div.getElementsByTagName("IFRAME");

      if (this.noChatFrame) {
        this.v3Frame = window;
        this.initV3Frame();
        additionalTags();
        return;
      }

      if (!this.isLegacy) {
        if (iframes.length > 0) {
          var oDiv = document.getElementById("nuanMessagingFrame");
          if (!oDiv) {
            oDiv = doc.createElement("div");
            oDiv.id = "nuanMessagingFrame";
            oDiv.classList.add("nuance-chat-floating-container");
            bdy.appendChild(oDiv);
          }
          oDiv.appendChild(iframes[0]);
          v3Lander.modernSkin = true;
        }
      } else {
        for (var ix = iframes.length - 1; ix > -1; --ix) {
          bdy.appendChild(iframes[ix]);
        }
      }
      additionalTags();
    }

    v3Lander.fixV3IFrames(div);

    function additionalTags() {
      var divs = div.getElementsByTagName("DIV");
      for (var ix = divs.length - 1; ix > -1; --ix) {
        bdy.appendChild(divs[ix]);
      }
    }
  };

  function getEnvFromConfig() {
    var landerConfig =
      v3Lander.getOpenerV3LanderConfig() ||
      v3LanderConfig.parent ||
      window.v3LanderConfig;
    return landerConfig ? landerConfig["env"] : null;
  }

  /**
   * Dynamically load a script by injecting a script tag into the DOM
   *
   * @param {string} name
   * @param {boolean} [useMediaServer=false]
   * @param {boolean} [useClientDomain=false]
   * @param {boolean} [async=true]	Browsers load scripts with async=true by default.
   * 									Set async to false only when loading
   * 									scripts that must be executed in order.
   * @param {function=} errorCallback - will be called if script failed to load
   * @param {boolean} [useResolvePageWSDomain=false]
   */
  function loadScript(
    name,
    useMediaServer,
    useClientDomain,
    async,
    errorCallback,
    useResolvePageWSDomain
  ) {
    var bdy = document.getElementsByTagName("BODY");
    if (bdy && bdy[0]) {
      var srctag = document.createElement("SC" + "RIPT");
      if (v3Lander.noJSHosting && useClientDomain) {
        /** @type {string} */
        v3LanderConfig.clientStaticUrl = v3Lander.getV3LanderConfigProperty(
          "clientStaticUrl",
          v3Lander.staticClientURL
        );
        srctag.src =
          secureProtocol(window.v3LanderConfig.clientStaticUrl) + name;
      } else if (useMediaServer) {
        srctag.src =
          secureProtocol(
            window.v3LanderConfig.vanityDomain ||
              v3Lander.mediaServer ||
              v3Lander.vanityDomain
          ) + name;
      } else if (useResolvePageWSDomain) {
        srctag.src = secureProtocol(v3Lander.resolvePageWSDomain) + name;
      } else {
        srctag.src =
          secureProtocol(
            window.v3LanderConfig.vanityDomain || v3Lander.vanityDomain
          ) + name;
      }
      srctag.onerror = function () {
        if (typeof errorCallback == "function") {
          errorCallback();
        }
      };
      srctag.async = async !== false;
      srctag.type = "text/javascript";
      srctag.charset = "utf-8";
      srctag.language = "javascript";
      bdy[0].appendChild(srctag);
    }
  }

  v3Lander.requestPage = function requestPage() {
    this.resolvePage();
  };

  v3Lander.getPage = function getPage() {
    return this.page;
  };

  v3Lander.getContentGroupIDs = function getContentGroupIDs() {
    return this.cgIDs;
  };

  /**
   * Send request to TagServer to:
   * 1. get BUs that can fire at v3Lander page if enabled BUP mode;
   * 2. get page if enabled RPL mode.
   */
  v3Lander.resolvePage = function resolvePage() {
    var urlPath =
      "/launch/resolvePage?siteID=" +
      this.siteID +
      "&url=" +
      encodeURIComponent(document.URL) +
      "&codeVersion=" +
      encodeURIComponent(this.codeVersion);
    if (!this.useResolvePageWSDomain) {
      urlPath = "/tagserver" + urlPath;
    }
    var overriddenPageId = null;
    if (window.inqSiteID) {
      overriddenPageId = window.inqSiteID;
    } else if (window.parent && window.parent.inqSiteID) {
      overriddenPageId = window.parent.inqSiteID;
    }

    if (overriddenPageId) {
      urlPath += "&overridePageId=" + encodeURIComponent(overriddenPageId);
    }
    loadScript(urlPath, false, false, true, null, this.useResolvePageWSDomain);
  };

  /**
   * v3Lander function call from script that load from '/tagserver/launch/resolvePage' URL.
   *
   * @param data resolved at TagServer (BUs list, current page, contend group ids)
   */
  v3Lander.applyPage = function applyPage(data) {
    var contains = function (a, obj) {
      for (var i = 0; i < a.length; i++) {
        if (a[i] === obj) {
          return true;
        }
      }
      return false;
    };
    var prepareMbusList = function (bUnits) {
      var mbusToLoad = [];
      // check duplicate and push
      for (var i = 0; i < bUnits.length; i++) {
        if (!contains(mbusToLoad, bUnits[i])) {
          mbusToLoad.push(bUnits[i]);
        }
      }
      return mbusToLoad;
    };

    if (this.isBupMode && data.bUnits) {
      this.mbusToLoad = prepareMbusList(data.bUnits);
    }

    if (this.isRplMode && data.page) {
      this.page = data.page;
    }

    if (this.isRplMode && data.cgIDs) {
      this.cgIDs = data.cgIDs;
    }

    // check if Inq#reinitChat callback is required (only for RPL sites)
    if (this.reInitChatData) {
      window.Inq.reinitChatV3Callback(
        this.reInitChatData.pageID,
        this.reInitChatData.data
      );
      this.reInitChatData = null;
    } else {
      this.createV3Frame();
    }
  };

  v3Lander.initSiteDefaultData = function initSiteDefaultData(
    siteData,
    rulesEngineData,
    landingData
  ) {
    this.landingData = landingData;
    this.inqSiteDataFun = siteData;
    this.inqRulesEngineFun = rulesEngineData;
    if (!this.isBupMode || parent.v3Lander.mbusToLoad.length === 0) {
      loadTcFramework();
    } else {
      loadMbuData();
    }
  };

  v3Lander.initProgramRulesData = function (programRulesConfig) {
    this.programRulesConfig = programRulesConfig;
    loadScript(generatePath("site_" + this.siteID + "_default.js"), true, true);
  };

  function loadTcFramework() {
    loadScript(generatePath(v3Lander.tcFrameworkName), true, true);
  }

  function generatePath(filename) {
    /*
     * RTDEV-1238: "codeVersion" parameter is used for investigation only
     * and contains a time of inqChatLaunch***.js and tcFramework***.js generation as number.
     * The parameter is defined in inqChatLaunch***.js in v3Lander object
     * (see code of inqChatLaunch.jsp) and is added as URL parameter
     * for tcFramework***.js and InqFramework.js.
     */
    var path =
      (window.v3LanderConfig.vanityDomain ? "/chatskins" : "/media") +
      "/launch/";
    if (v3Lander.noJSHosting) {
      path = "/";
    }

    return (
      path +
      filename +
      "?codeVersion=" +
      encodeURIComponent(v3Lander.codeVersion)
    );
  }

  function loadMbuData() {
    if (v3Lander.isJSSDK) {
      var buIds = "";
      for (var i = 0; i < parent.v3Lander.mbusToLoad.length; i++) {
        var mbuID = parent.v3Lander.mbusToLoad[i];
        buIds += mbuID.toString() + ";";
      }
      var serverUrl =
        v3Lander.vanityDomain +
        "/tagserver/v1/jssdkApi/all?siteID=" +
        v3Lander.siteID +
        "&buIds=" +
        buIds;
      loadJSON(
        serverUrl,
        function (responseText) {
          var jsonMbuData = JSON.parse(responseText);
          v3Lander.jsonMbuData = jsonMbuData;
          for (var i = 0; i < parent.v3Lander.mbusToLoad.length; i++) {
            var mbuID = parent.v3Lander.mbusToLoad[i];
            var mbuRuleData = {
              rules: JSSDK_RENDERER.RenderRules(jsonMbuData[mbuID.toString()]),
            };
            v3Lander.applyMbuRuleData(mbuRuleData);
          }
        },
        "MBU Data"
      );
    } else {
      for (var i = 0; i < parent.v3Lander.mbusToLoad.length; i++) {
        v3Lander.loadMbuDataForBU(parent.v3Lander.mbusToLoad[i]);
      }
    }
  }

  /**
   * Calls to tagserver to load the appropriate rules file for a given business unit.
   * @param buID {Number}
   * @param callback [Function]
   */
  v3Lander.loadMbuDataForBU = function loadMbuDataForBU(buID, callback) {
    if (!!callback) {
      v3Lander.buDataCallbackFcn = callback;
    }
    loadScript(
      (v3Lander.noJSHosting ? "/" : "/chatskins/launch/") +
        "site_" +
        v3Lander.siteID +
        "_bu_" +
        buID +
        ".js?codeVersion=" +
        encodeURIComponent(v3Lander.codeVersion),
      false,
      true
    );
  };

  v3Lander.applyMbuRuleData = function applyMbuRuleData(mbuRuleData) {
    if (this.buDataCallbackFcn) {
      this.buDataCallbackFcn(mbuRuleData);
      this.buDataCallbackFcn = null;
    } else {
      v3Lander.loadedMbuRuleDataFuns[v3Lander.loadedMbuRuleDataFuns.length] =
        mbuRuleData;
      // check that we already loaded exactly the same amount of mbu rule data and initiate framework loading
      if (
        v3Lander.loadedMbuRuleDataFuns.length ==
        parent.v3Lander.mbusToLoad.length
      ) {
        loadTcFramework();
      }
    }
  };

  function insertLandingTag() {
    if (v3Lander.isJSSDK) {
      /*
       * Helper file for jsSDK which contains are dynamic js from br.
       * we enable helper file to be loaded from different path based
       * on the client environment
       */
      var helperPath = "";
      var env = getEnvFromConfig();
      if (v3Lander.noJSHosting && env) {
        helperPath = "/" + env;
      }
      helperPath += generatePath(
        "site_" + v3Lander.siteID + "_default_helper.js"
      );

      var defaultJSSDKPath = generatePath(
        "site_" + v3Lander.siteID + "_default_jssdk.js"
      );

      var useMediaServer = true;
      var useClientDomain = true;

      /*
       * site_*_default_helper.js defines a global variable (JSSDK_HELPER)
       * that is used by site_*_default_jssdk.js.
       * If we don' t load these with async=false, it can crash if
       * default_jssdk executes before default_helper
       */
      var async = false;

      loadScript(helperPath, useMediaServer, useClientDomain, async);
      loadScript(defaultJSSDKPath, useMediaServer, useClientDomain, async);
    } else {
      loadScript(
        generatePath(v3Lander.isObfuscated ? "pr.min.js" : "pr.dev.js"),
        true,
        true,
        true
      );
    }
  }

  /*
   * Load postToServer.js on a client domain
   */
  function insertPostToServerTag() {
    loadScript(
      (v3Lander.noJSHosting ? "/" : "/tagserver/") +
        v3Lander.postToServerName +
        "?siteID=" +
        v3Lander.siteID +
        "&codeVersion=" +
        encodeURIComponent(v3Lander.codeVersion),
      false,
      true
    );
  }

  v3Lander.parseC2CQueryString = function parseC2CQueryString() {
    // Obtain additional customer data from query string if provided
    var queryStringIndex = window.location.href.indexOf("?C2C");
    var queryString = window.location.href.substring(queryStringIndex + 4);
    if (queryString.length > 1) {
      var c2cQueryData = "{";
      var queryStringPairs = queryString.substring(1).split("&");
      for (var i = 0; i < queryStringPairs.length; i++) {
        var pair = queryStringPairs[i].split("=");
        if (pair.length >= 1 || pair.length <= 2) {
          c2cQueryData +=
            (i == 0 ? "" : ", ") +
            pair[0] +
            ": " +
            (pair.length == 2 ? '"' + unescape(pair[1]) + '"' : '""');
        }
        c2cQueryData += "}";
        // Save JSON into title
        v3Lander.c2cQueryData = c2cQueryData;
      }
    }
  };

  v3Lander.renderC2CDiv = function renderC2CDiv() {
    // Fix up the iframe so it does not look ugly, no margins, borders, or scroll bars
    document.body.style.cssText =
      "border-style: none; border-width: 0px;" +
      " margin: 0px; padding: 0px; overflow: hidden; overflow-x:hidden; overflow-y: hidden;";
    // Create the DIV layer. We want: id = frame.name
    var c2cdiv = document.createElement("DIV");
    c2cdiv.id = window.name;

    // Attach the new div to the document body
    document.body.appendChild(c2cdiv);
    // Save the div layer for set source callback
    v3Lander.embeddedDiv = c2cdiv;
    // Set the callback routine for C2C
    c2cdiv["setSource"] = v3Lander.setSource;
  };

  v3Lander.onDomReady = function onDomReady() {
    if (v3Lander.domReady) {
      return;
    }
    v3Lander.domReady = true;
    if (window.location.href.indexOf("?C2C") !== -1) {
      try {
        v3Lander.renderC2CDiv();
        v3Lander.parseC2CQueryString();
        // Register the div layer with 200 0.5 second retries
        v3Lander.registerDiv(200);
      } catch (e) {}
      return;
    }
    /*
     * Avoiding creating v3Frame when client page inside
     * IFrame with the same domain as parent window.
     * Behaivior is configured with Site option 'allowTaggingInsideFrameSet'
     */
    try {
      if (
        window != window.parent &&
        !this.isAtHostedFileURL &&
        window.document.domain == window.parent.document.domain
      ) {
        if (this.allowTaggingInsideFrameSet) {
          if (!window.frameElement) {
            return;
          }
        } else {
          return;
        }
      }
    } catch (e) {
      /*
       * parent property access could case permission denied
       * error in case of cross-domain access
       */
    }
    if (!this.v3Frame) {
      if (this.isBupMode || this.isRplMode) {
        this.requestPage();
      } else {
        this.createV3Frame();
      }
    } else {
      this.initV3Frame();
    }
  };

  v3Lander.injectIntoParent = function injectIntoParent() {
    function whenLoaded() {
      win.v3Lander = window.v3Lander;
      instance.createV3Frame(win);
    }

    var instance = this;
    var win = top.top;
    var doc = win.document;
    if (!doc.readyState) {
    } else if (doc.readyState === "complete" || doc.readyState === "loaded") {
      whenLoaded();
    } else {
      if (window.addEventListener) {
        window.addEventListener("load", whenLoaded, true);
      } else if (window.attachEvent) {
        window.attachEvent("onload", whenLoaded);
      }
    }
  };

  v3Lander.setDomReadyTimeout = function setDomReadyTimeout(t) {
    setTimeout(function () {
      v3Lander.onDomReady();
    }, t || 0);
  };

  v3Lander.testReady = function testReady() {
    /*
		 * Test for jQuery and jQuery property " isReady"
		 * if it is true, then we know we do not need to test for DOM ready

		 * We establish a new boolean called alreadyReady.
		 * We test for jquery by testing for !!$
		 * We test for isReady attribute by !!$.isReady
		 * We test for isReady set to true by $.isReady==true

		 * So if we throw we have alreadyReady initialized to false

		 * If we see we are already ready, we call onDomReady and we return.
		 * We want to return because we DO NOT WANT to do any bad document.writes
		 * after dom ready, v3Lander is a no-no.

		 * So a side effect of late dom ready detection is we do not get
		 * Back-Button testing for IE only. All other browsers are good to go.
		 */
    var WAIT_PERIOD = 100;
    var skipDomReadyTest = v3Lander.skipDomReadyTest;

    if (typeof jQuery != "undefined" && jQuery.isReady) {
      v3Lander.setDomReadyTimeout(1);
    } else if (skipDomReadyTest && !v3Lander.v3Frame) {
      v3Lander.setDomReadyTimeout(1);
    } else if (typeof document.readyState == "undefined") {
      if (document.addEventListener) {
        document.addEventListener("load", v3Lander.setDomReadyTimeout, false);
        document.addEventListener(
          "DOMContentLoaded",
          v3Lander.setDomReadyTimeout,
          false
        );
      }
      v3Lander.setDomReadyTimeout(WAIT_PERIOD);
    } else {
      /*
       * Identifying real IE version by trident version, works for compatibility mode too.
       * Trident/7.0	IE 11
       * Trident/6.0	IE 10
       * Trident/5.0	IE 9
       */
      var tridentVersion = navigator.userAgent.match(/Trident\/(\d+)/);
      var newIeVersion =
        tridentVersion &&
        tridentVersion.length == 2 &&
        parseInt(tridentVersion[1]) >= 6;
      if (document.readyState == "complete" && newIeVersion) {
        v3Lander.setDomReadyTimeout();
      } else if (
        document.addEventListener ||
        (newIeVersion && document.attachEvent)
      ) {
        // Due to IE compatibility meta tag addEventListener is undefined on a popup chat window
        if (/loaded|complete/.test(document.readyState)) {
          v3Lander.setDomReadyTimeout();
        } else {
          // We are not DOM ready so let's try again
          setTimeout(arguments.callee, 100);
        }
      }
    }
  };

  if (v3Lander.isExitChat) {
    /*
     * v3Lander method works in conjuction with ExitHook class to fire
     * onBeforeUnload event when user attempts to leave
     * the page. If both ExitConfirm and ExitHook initialized,
     * ExitConfirm's onbeforeunload function takes care
     * of firing onBeforeUnload event on behalf of ExitHook.
     */
    v3Lander.prepareBeforeUnloadForEH = function prepareBeforeUnloadForEH() {
      // don't replace onbeforeunload handler set by EC
      if (!inqFrame.Inq.EC.isInitialized()) {
        window.onbeforeunload = function (evt) {
          inqFrame.Inq.EH.fireBeforeUnloadEvent();
        };
      }
    };

    /*
     * v3Lander method works in conjuction with ExitConfirm class to
     * properly attach and invoke onbeforeunload method (from main window
     * as IE will not recognize nor allow any attachment from
     * an outer frame or window). Code delineation is key here and very touchy.
     */
    v3Lander.prepareBeforeUnload = function prepareBeforeUnload(
      atxt,
      ctxt,
      cancelFcn,
      showImage,
      imageElement
    ) {
      window.onbeforeunload = function (evt) {
        if (inqFrame.Inq.EH.isInitialized()) {
          inqFrame.Inq.EH.fireBeforeUnloadEvent();
        }

        if (inqFrame.Inq.EC.update()) {
          if (showImage) {
            var positionX = (window.innerWidth - imageElement.width) / 2;
            var positionY = (window.innerHeight - imageElement.height) / 2;
            /*
             * We should change style, not cssText,
             * because it requires time for browser to parse cssText.
             * Also Chrome 4.1 and above doesn't parse cssText when
             * 'onbeforeunload' alert is shown.
             */
            var style = inqFrame.frameElement.style;
            style["display"] = "block";
            style["z-index"] = "9999999";
            style["overflow"] = "hidden";
            style["position"] = "absolute";
            style["height"] = imageElement.height + "px";
            style["width"] = imageElement.width + "px";
            style["left"] = positionX + "px";
            style["top"] = positionY + "px";
            style["border-style"] = "none";
            style["border-width"] = "0px";
            inqFrame.Inq.CHM.isImagePosition = true;
          }

          // fire all rules listening for "BeforeExitConfirmation" event
          inqFrame.Inq.EC.fireBeforeExitConfirmationEvent();

          // alert throws error in FF 27 and higher
          if (atxt && navigator.userAgent.indexOf("Firefox") < 0) {
            alert(atxt);
          }

          // disconnect listener or circular ref will result in url "forward" actions
          window.onbeforeunload = null;

          /*
           * For cancellation deferment. IE pends v3Lander timeout invocation
           * until the user replies to the confirm dialog (only if "cancel" selected).
           * FF will invoke the timed code regardless of the users
           * choice or outcome which makes us defer a second time for 1 sec
           * (see _doActions() method in ExitConfirm in InqClasses.jsp)
           */
          setTimeout(cancelFcn, 200);
          return String(ctxt);
        }
      };
    };
  }

  v3Lander.start = function start() {
    try {
      this.assignDomain();
      v3Lander.v3Frame =
        window.frameElement && window.frameElement.id === FRAME_ID;
    } catch (e) {
      v3Lander.v3Frame = false;
    }
    /*
     * Execute the ExitChat back button detection functionality
     * only if the site is configured for the Exit Chat functionality
     */
    if (v3Lander.isExitChat) {
      /*
       * Browser Back detection support:
       * inqChatLaunch script is designed to load in two stages:
       * 1st when visitor lands on customer site,
       * 2nd - from the hosted file (site.hostedFileURL)
       * which is itself loaded by v3Lander script.
       * There's no need to embed BB detection support iframe twice (MAINT22-40).
       * As reported in MAINT22-296 TotalGym sandbox site fails
       * to fire onload event for the main window
       * which makes browser back detection not working.
       * For v3Lander reason tcBBFrame is created at the 2nd
       * load of v3Lander script - from from the hosted file.
       */
      if (this.isAtHostedFileURL) {
        this.prepBBDetect();
      }
    }
    v3Lander.testReady();
  };

  v3Lander.establishHostedFileURL();
  if (window.location.href.indexOf("surveys/launchNativePostChatSurvey") > -1) {
    /*
     * In launchNativePostChatSurvey mode, it is at hosted file URL
     * if url contains hostedFileURL=true.
     * See createV3Frame where it inserts hostedFileURL=true into the url.
     */
    v3Lander.isAtHostedFileURL =
      window.location.href.indexOf("hostedFileURL=true") > -1;
  } else {
    v3Lander.isAtHostedFileURL =
      window.location.href.indexOf(v3Lander.hostedFileURL) > -1;
  }
  v3Lander.assignDomain();
  /*
   * Queries are checked for "alternate" uses of v3Lander file:
   * ?CLEAR- v3Lander will clear all the chat cookies in first party domain
   * ?BLNK - Do nothing.  v3Lander is used for opening a somewhat blank document for subsequent decoration
   * ?C2C  - v3Lander is for inserting a C2C image in an IFrame
   * ?RSC2C- Resizes the C2C image in an IFrame
   * ?XFRM - Used to transfer data to the IJSF from an Orbeon Xform. It is in a different domain.
   * hostedFileURL, siteID, vanityDomain - Used by surveys/launchNativePostChatSurvey servlet.
   * If none of these paterns match,
   * then we use v3Lander Javascript file for DOM-Ready detection.
   */
  if (window.location.href.indexOf("?CLEAR") != -1) {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var cookieName = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        cookieName + "=;Path=/;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
  } else if (window.location.href.indexOf("?BLNK") != -1) {
  } else if (window.location.href.indexOf("?C2C") != -1) {
    /*
     * v3Lander code is performed for the display of C2C in an internal
     * IFRAME of the same domain as the main window
     */
    v3Lander.testReady();
  } else if (window.location.href.indexOf("?INJECT") != -1) {
    v3Lander.injectIntoParent();
  } else if (window.location.href.indexOf("?RSC2C") != -1) {
    /*
     * v3Lander code is for resizing the iframe in the inner IFRAME (parents parent)
     * The name field of the window is "RESIZE||iframename||width||height
     */
    v3Lander.resizeAnscestorIframe();
  } else if (window.location.href.indexOf("?POST2SERVER") != -1) {
    insertPostToServerTag();
  } else if (
    !!window.name &&
    window.name.indexOf("||") != -1 &&
    v3Lander.isAtHostedFileURL
  ) {
    if (
      !v3Lander.disableXframeToIjsf &&
      typeof v3Lander.xframeToIjsf === "function"
    ) {
      if (window.location.search == "?XFRM") {
        v3Lander.xframeToIjsf();
        window.close();
      }
    }
  } else {
    if (!window.v3LanderConfig.customLaunching) {
      v3Lander.start();
    }
  }
  if (
    window === window.parent &&
    typeof CEAPI_POST_CHAT_SURVEY_DATA != "undefined" &&
    CEAPI_POST_CHAT_SURVEY_DATA != null
  ) {
    // shows "loading" instead of blank screen.
    if (CEAPI_POST_CHAT_SURVEY_DATA.skinVersion) {
      v3Lander.showLoaderAnim();
    } else {
      v3Lander.showLoader();
    }
  }
})();
